/**
 * @file 合作咨询 url
 */

export default {
    getBDStoken: {
        url: '/exp/user/getBDStoken'
    },
    getloginUser: {
        url: '/exp/user/loginUser'
    }
} as Record<string, NetTypes.Api>;
